import { Component, Input } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';

@Component({
  selector: 'app-skeleton-loader',
  imports: [
    SkeletonModule,
    CommonModule,
    CardModule
  ],
  standalone: true,
  templateUrl: './skeleton-loader.component.html',
  styleUrls: ['./skeleton-loader.component.scss']
})
export class SkeletonLoaderComponent {
  @Input() type: string = ''; // tipo do layout
  @Input() count: number = 1; // quantos skeletons mostrar
}
